
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as team6aovK0Nts91CyC2cJBQ8zGWUTa1XBePmnYwjh0dXPukMeta } from "/vercel/path0/pages/team.vue?macro=true";
import { default as zoekVp9TEDOWxcOuvNmyn1vnBXDDVeArHo1xP1b1EC3yjuUMeta } from "/vercel/path0/pages/zoek.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93eD0_45aLJH_SWaJVw5CBvPn8cEE2xWIMXlvr23TEyf8PMMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as indexDbe5pTUa3TZ6zhL3DfOOwYQIKYO3VdLxrz_45FQoTJxj8Meta } from "/vercel/path0/pages/nieuws/index.vue?macro=true";
import { default as _91slug_93pPCTQOiNITftP3SXasvGcPAMXdTipmzYN3Uet9nDKiQMeta } from "/vercel/path0/pages/nieuws/[slug].vue?macro=true";
import { default as indexWf0MaczIVgLaIX_45YanuNkGi_45skc6cfQ0nchkMR3S7aQMeta } from "/vercel/path0/pages/projecten/index.vue?macro=true";
import { default as indexmzKFfBWHYSJX6HCQNKy8x_t8FYmvwxh7YyyobFjHkFgMeta } from "/vercel/path0/pages/quickscan/index.vue?macro=true";
import { default as indexRsJsMEjyesLYRfymNPka7R0ZBP96VlNVlDPJqcFQeqwMeta } from "/vercel/path0/pages/steun-ons/index.vue?macro=true";
import { default as _91slug_93mWiTPrc8BFvFVsOcJA3BljLiRcz7oi1TsUAC__4546oroMeta } from "/vercel/path0/pages/projecten/[slug].vue?macro=true";
import { default as indexMHC0fx5aS38vCe4juipBo0erjXGKEI7np9AWc9u2ljEMeta } from "/vercel/path0/pages/regelingen/index.vue?macro=true";
import { default as _91slug_93ZCTkCaLzS25_4MzG_45cuyRzOQVHgotkMlYMoOXIWY3vAMeta } from "/vercel/path0/pages/steun-ons/[slug].vue?macro=true";
import { default as _91slug_934CLW5Uazb_1iwJxBdUHggh1Xx9U5rdy0myFNaTH_LVAMeta } from "/vercel/path0/pages/regelingen/[slug].vue?macro=true";
import { default as _91_46_46_46slug_937UtsRVXUG4YEbMpr_45rz_76NIsJCQDcMR9fE_451Q_uKdwMeta } from "/vercel/path0/pages/quickscan/[...slug].vue?macro=true";
export default [
  {
    name: "team___nl",
    path: "/team",
    component: () => import("/vercel/path0/pages/team.vue")
  },
  {
    name: "zoek___nl",
    path: "/zoek",
    component: () => import("/vercel/path0/pages/zoek.vue")
  },
  {
    name: "index___nl",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "slug___nl",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "nieuws___nl",
    path: "/nieuws",
    component: () => import("/vercel/path0/pages/nieuws/index.vue")
  },
  {
    name: "nieuws-slug___nl",
    path: "/nieuws/:slug()",
    component: () => import("/vercel/path0/pages/nieuws/[slug].vue")
  },
  {
    name: "projecten___nl",
    path: "/projecten",
    meta: indexWf0MaczIVgLaIX_45YanuNkGi_45skc6cfQ0nchkMR3S7aQMeta || {},
    component: () => import("/vercel/path0/pages/projecten/index.vue")
  },
  {
    name: "quickscan___nl",
    path: "/quickscan",
    component: () => import("/vercel/path0/pages/quickscan/index.vue")
  },
  {
    name: "steun-ons___nl",
    path: "/steun-ons",
    component: () => import("/vercel/path0/pages/steun-ons/index.vue")
  },
  {
    name: "projecten-slug___nl",
    path: "/projecten/:slug()",
    component: () => import("/vercel/path0/pages/projecten/[slug].vue")
  },
  {
    name: "regelingen___nl",
    path: "/regelingen",
    component: () => import("/vercel/path0/pages/regelingen/index.vue")
  },
  {
    name: "steun-ons-slug___nl",
    path: "/steun-ons/:slug()",
    component: () => import("/vercel/path0/pages/steun-ons/[slug].vue")
  },
  {
    name: "regelingen-slug___nl",
    path: "/regelingen/:slug()",
    component: () => import("/vercel/path0/pages/regelingen/[slug].vue")
  },
  {
    name: "quickscan-slug___nl",
    path: "/quickscan/:slug(.*)*",
    component: () => import("/vercel/path0/pages/quickscan/[...slug].vue")
  }
]